module.exports = __webpack_public_path__ + "24d59885c7ba8a38727a9cd16ddc4214.svg";